module.exports = __webpack_public_path__ + "img/appstore.54f3adf1.svg";